import type { ReactNode } from 'react';
export function GraphProvider({ children }: { children: ReactNode }) { return <>{children}</>; }
